import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { MaterialPreviewSection } from '../components/MaterialPreviewSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
import { StickyCTABar } from '../components/StickyCTABar';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-298" data-mp="2zjymru2xailg">
      <HeroSection data-id="element-299" data-mp="33k8xtl5knz76" />
      <ProofSection data-id="element-300" data-mp="33lk4bsqejl1z" />
      <ProblemSection data-id="element-301" data-mp="33l1xy3a0zqgc" />
      <SystemSection data-id="element-302" data-mp="33ifp80bef4wj" />
      <ModulesSection data-id="element-303" data-mp="38jvey5oitzl9" />
      <MaterialPreviewSection data-id="element-304" data-mp="38jd689ko9swg" />
      <BonusSection data-id="element-305" data-mp="38iaj8cqh0alt" />
      <UrgencySection data-id="element-306" data-mp="38hseerpqso2a" />
      <PricingSection data-id="element-307" data-mp="3da22s3b7lg2g" />
      <TestimonialsSection data-id="element-308" data-mp="3dbdecpawbs44" />
      <GuaranteeSection data-id="element-309" data-mp="3dbmu7k288iw3" />
      <FAQSection data-id="element-310" data-mp="3i9extbc8htg4" />
      <FinalCTA data-id="element-311" data-mp="3i9y4tx0cixfd" />
      <Footer data-id="element-312" data-mp="3i8d9i567jagg" />
      <PurchasePopup data-id="element-313" data-mp="3i8n1fyatbros" />
      <StickyCTABar data-id="element-314" data-mp="3ibizrnqkoidr" />
    </main>;
}